module.exports = __webpack_public_path__ + "static/image006-f615b111ee2005878cbc987d14126c69.jpg";